/**
 * 获取是否应该在计价和下单接口中使用 JSON Content-Type header
 * @returns {boolean} true: 需要添加 header, false: 不需要添加 header
 */
export function getShouldUseJsonHeader(): boolean {
  try {
    const grayValue = sessionStorage.getItem('calculate_place_order_form_to_json_gray');
    return grayValue === 'true';
  } catch (error) {
    console.error('Failed to read gray scale config from sessionStorage:', error);
    // 默认不添加 header，保持稳定性
    return false;
  }
}

/**
 * 根据灰度配置动态构建请求 headers
 * @param baseHeaders 基础 headers 对象
 * @returns {object} 处理后的 headers 对象
 */
export function buildRequestHeaders(baseHeaders: Record<string, any> = {}): Record<string, any> {
  const shouldUseJsonHeader = getShouldUseJsonHeader();
  
  if (shouldUseJsonHeader) {
    return {
      ...baseHeaders,
      'Content-Type': 'application/json',
    };
  }
  
  return baseHeaders;
}
